import React, { useState } from 'react'
import {
  Button,
  Input,
  Modal,
  Form,
  Tooltip,
  message,
  Spin,
  Row,
  Col
} from 'antd'
import IntlMessages from '../util/IntlMessages'
import ds from '../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useStore, useDispatch } from 'react-redux'
import { loadData } from '../appRedux/actions/Setting'
import { userLogOut } from '../appRedux/actions/Auth'
import { BEHAVIOUR_TYPE } from '../Services/DataServices'
import { notAllowMsgCheck } from '../appRedux/actions'
import { TableName } from '../constants/TableName'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const AddBrand = () => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()
  const [visible, setVisible] = React.useState(false)
  const [confirmLoading, setConfirmLoading] = React.useState(false)
  const [getIsShow, setIsShow] = React.useState(false)
  const [isSpinningLoading, setSpinningLoading] = React.useState(false)

  React.useEffect(() => {
    //getListingTableData();
  }, [])

  const handleOk = () => {
    setConfirmLoading(true)
    setTimeout(() => {
      setVisible(false)
      setConfirmLoading(false)
    }, 2000)
  }

  const handleCancel = () => {
    //;
    //props['IsShow'] = false;
    setVisible(false)
  }

  const onFinishFailed = errorInfo => {
    message.error(<IntlMessages id='products.brands.failedbrand' />)
  }

  const onFinish = async values => {
    setVisible(false)
    setIsShow(true)
    //setSpinningLoading(true);
    //history.push("/Dashboard/products/Brands");
    let addUpdateDeleteBrands = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }
    await ds
      .addUpdateDeleteBrands(
        {
          BrandName: values.BrandName,
          BrandDescription: values.BrandDescription,
          IsRemove: false
        },
        BEHAVIOUR_TYPE.POST
      )
      .then(response => {
        addUpdateDeleteBrands.data = response.data
        dispatch(loadData(true))
      })
      .catch(e => {
        setIsShow(false)
        notAllowMsgCheck(e)
      })

    if (addUpdateDeleteBrands.data.msgCode == 'GENERAL_SUCCESS') {
      //setSpinningLoading(false);
      // message.success("Successfully Added " + form.getFieldValue("BrandName"));
      message.success('Product Brand added Successfully')
      //history.push("/Dashboard/products/Brands");
      setTimeout(() => {
        setIsShow(false)
        //window.location.assign("/Dashboard/products/Brands");
      }, 2000)
    }

    if (addUpdateDeleteBrands.data.msgCode == 'GENERAL_ERROR') {
      //etSpinningLoading(false);
      setIsShow(false)
      message.error(addUpdateDeleteBrands.data.msgDescription)
    }
    //setSpinningLoading(false);
    form.resetFields()
    setTimeout(() => {
      setIsShow(false)
    }, 2000)
  }

  const showModal = () => {
    //
    //props['isRecuring'] = true;
    //form.setFieldsValue({ BrandName: asd});
    setVisible(true)
  }
  const valideDuplicateName = (rule, value, callback) => {
    let body = {
      TableName: TableName.Brands,
      SearchValue: value,
      ID: '0&&_bd98-6131-47dd-8ac8-4bd1856d2a60'
    }
    const getIsExist = ds.checkIsNameExist(body, BEHAVIOUR_TYPE.POST)
    getIsExist
      .then(response => {
        if (response) {
          //setIsOrderNumberExist(response);
          callback('This Brand name exists. Add a different one.')
        } else {
          callback()
        }
      })
      .catch(e => {})
  }

  return (
    <div>
      {getIsShow ? (
        <div style={{ marginRight: '660px' }}>
          <Spin
            tip={<IntlMessages id='products.addeditpriceprod.savebook' />}
            spinning={getIsShow}
            size='large'
          ></Spin>
        </div>
      ) : (
        <div>
          <Button
            className='dk-btn-add Brands-addbtn'
            type='primary'
            onClick={showModal}
            size='large'
          >
            <IntlMessages id='products.brands.addbrand' />
          </Button>
          <Modal
            title={<IntlMessages id='products.brands.newbrand' />}
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            centered={true}
            width={'402px'}
            className='NewBrand-Modal'
            footer={
              <>
                <Button
                  form='brands'
                  className='dk-btn-add'
                  type='primary'
                  htmlType='submit'
                >
                  <IntlMessages id='products.brands.addbrand' />
                </Button>
              </>
            }
          >
            <Form
              {...formItemLayout}
              form={form}
              name='brands'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{
                prefix: '86'
              }}
              scrollToFirstError
            >
              <Form.Item
                className='form-inner-pad-0'
                name='BrandName'
                label={
                  <span>
                    <IntlMessages id='products.brands.brandname' />
                    <Tooltip title='Brand Name'></Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: 'Please enter Brand name',
                    whitespace: true
                  },
                  {
                    validator: valideDuplicateName
                  }
                ]}
              >
                <Input placeholder='Brand Name' maxLength={30} />
              </Form.Item>
              <Form.Item
                className='form-inner-pad-0'
                name='BrandDescription'
                label={
                  <span>
                    <IntlMessages id='products.brands.description' />
                    <Tooltip title='Brand Description'></Tooltip>
                  </span>
                }
              >
                <Input placeholder='Brand Description' maxLength={250}/>
              </Form.Item>
            </Form>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default AddBrand
